"use client";

import { useSearchParams } from "next/navigation";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ThemeWrapper } from "@/components/layout/ThemeWrapper";

export function AuthShell({ children }: { children: React.ReactNode }) {
  const redirectParam = useSearchParams().get("redirect") || "";
  return (
    <ThemeWrapper redirectParam={redirectParam}>
      <Header redirectParam={redirectParam} />
      <main className="min-h-screen">{children}</main>
      <Footer redirectParam={redirectParam} />
    </ThemeWrapper>
  );
}
